import { render, staticRenderFns } from "./CreateGroupBtnDialog.vue?vue&type=template&id=261463fe&scoped=true"
import script from "./CreateGroupBtnDialog.vue?vue&type=script&lang=js"
export * from "./CreateGroupBtnDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261463fe",
  null
  
)

export default component.exports